import api from 'ApiConfig';

const authService = {
  //Super Admin
  adminOrg: async (schoolData) => {
    return api.post('/superadmin/create-code', { schoolData });
  },

  // Authentication
  adminRegister: async (schoolData) => {
    return api.post('/auth/signup', { schoolData });
  },
  adminCheckDetails: async (verifyData) => {
    return api.post('/auth/check-details', verifyData);
  },

  orgEmailExists: async (email) => {
    return api.post('/login/check-org-emailexists', { email });
  },

  userLogin: async (loginData) => {
    return api.post('/auth/login', loginData);
  },

  // User Management
  getCurrentUser: async () => {
    return api.post('/auth/current-user');
  },
  logout: async () => {
    return api.post('/auth/logout');
  },
  forgetPassword: async (email) => {
    return api.post('/auth/forgot-password', { email });
  },
  resetPassword: async (token, password) => {
    return api.post(`/login/reset-password/${token}`, {
      password,
    });
  },
  acceptPrivacyPolicy: async (data) => {
    return api.post(`/auth/accept-privacy-policy`, data);
  },
  updatePassword: async (oldPassword, newPassword, userId) => {
    return api.post(`/combinedroutes/update-password`, {
      oldPassword,
      newPassword,
    });
  },
};
export default authService;
